import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ts_grade_checked",
  "use": "icon-ts_grade_checked-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ts_grade_checked\">\n<circle cx=\"9\" cy=\"9\" r=\"9\" fill=\"#60BF52\" />\n<path d=\"M4 8.4375L7.30222 11.689C7.47682 11.8609 7.75761 11.859 7.92996 11.6849L13.5556 6\" stroke=\"#FAFBFE\" stroke-width=\"2.04762\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol